<template>
    <CompassDialog
        :visible.sync="showModal"
        size="small"
        :title="title"
        class="popup-warning-third-form"
        @closed="close"
    >
        <template slot="default">
            <div class="dialog__default">
                <CompassAlert
                    type="error"
                    :description="content"
                    :showIcon="false"
                    :action="null"
                    :showClose="false"
                />
            </div>
        </template>
        <template slot="footer">
            <div class="dialog__footer">
                <CompassButton
                    :label="$t.__('common.actions.cancel')"
                    type="secondary"
                    size="medium"
                    @click="close()"
                />
                <CompassButton
                    :label="$t.__('common.actions.confirm')"
                    type="primary"
                    size="medium"
                    class="ml-2"
                    @click="submit()"
                />
            </div>
        </template>
    </CompassDialog>
</template>

<script>
export default {
    props: {
        currentStore: {
            type: String,
            required: true,
        },
        contextType: {
            type: String,
            required: true,
        },
    },
    data() {
        return {
            showModal: true,
            context: {
                cancelThird: {
                    title: this.$l10n.__('Dissocier la société'),
                    content: this.$l10n.__(
                        'En dissociant la société de votre opportunité, les contacts liés à l’entreprise seront déliés.',
                    ),
                },
                cancelForm: {
                    title: this.$l10n.__('Annuler la création de l’opportunité'),
                    content: this.$l10n.__(
                        'En annulant la création de l’opportunité, la création de société et/ou de contact(s) seront perdus',
                    ),
                },
            },
        };
    },
    computed: {
        title() {
            return this.contextType ? this.context[this.contextType].title : '';
        },
        content() {
            return this.contextType ? this.context[this.contextType].content : '';
        },
    },
    methods: {
        close() {
            this.$emit('close', !this.showModal);
        },
        submit() {
            this.contextType === 'cancelThird'
                ? this.$store.dispatch(`${this.currentStore}/resetCompany`)
                : history.back();
            this.close();
        },
    },
};
</script>

<style lang="scss">
@import '~@sellsy/styleguide/src/_variables';

.popup-warning-third-form {
    .dialog {
        &__default {
            padding-bottom: 24px;
        }

        &__footer {
            display: flex;
            justify-content: flex-end;
            padding: 0 32px 24px 32px;
        }
    }
}
</style>
